
export const asArray = (value: any): any[] => {
  if (value === undefined) {
    return []
  }
  return Array.isArray(value) ? value : [value]
}
